import {
  GroupOrderShareDoneButton,
  GroupOrderShareHeader,
  GroupOrderShareLinkRow,
  GroupOrderShareActions,
} from './components';

// ─────────────────────────────────────────────────────────────────────────────

export const GroupOrderShare = {
  Header: GroupOrderShareHeader,
  LinkRow: GroupOrderShareLinkRow,
  ShareActions: GroupOrderShareActions,
  DoneButton: GroupOrderShareDoneButton,
};
